import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { ChargePointHasTariff } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/charge-point/charge-point-has-tariff.enum';
import { useTranslation } from 'react-i18next';

export interface ChargePointHasTariffFilterStateControllerProps {
  value: boolean;
  onRemove: FilteredItemProps['onRemove'];
}

export const ChargePointHasTariffFilterStateController = ({
  value,
  onRemove,
}: ChargePointHasTariffFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const chargePointHasTariff = value
    ? ChargePointHasTariff.TRUE
    : ChargePointHasTariff.FALSE;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="currency-euro-circle"
      label={t(
        `delmonicos-shared-sdk.outputs-charge-point-has-tariff.${chargePointHasTariff}`,
      )}
      onRemove={onRemove}
    />
  );
};
